// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","703":"component---src-pages-projects-project-key-tsx"}[chunkId] || chunkId) + "-" + {"245":"f8c3373238e74f24602a","453":"6bb9dfa4ce21d0c21457","522":"634e12a74372e6c75f7e","703":"8dc2b3158e4a464d9e4b"}[chunkId] + ".js";
};